import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { useSettings } from "src/@core/hooks/useSettings";
import Logo from "src/@core/components/logo";
import LoginParticlesBackground from "src/views/components/LoginParticlesBackground";

const RightWrapper = styled(Box)(({ theme }) => ({
  margin: "auto",
  [theme.breakpoints.up("md")]: {
    maxWidth: 550,
  },
}));

const AuthLayout = ({ children }) => {
  const theme = useTheme();
  const { settings } = useSettings();
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  const { skin } = settings;
  const hidden = useMediaQuery(theme.breakpoints.down("md"));

  if (isLoginPage) {
    return (
      <Box
        sx={{
          position: "relative",
          minHeight: "100vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <LoginParticlesBackground />
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 2, sm: 3 },
            py: { xs: 4, sm: 5 },
          }}
        >
          {hidden && (
            <Box sx={{ mb: 3, display: "flex", justifyContent: "center" }}>
              <Logo />
            </Box>
          )}
          {children}
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Grid container className="content-right" spacing={4}>
        <Grid size={12}>
          <Box className="content-center">
            <RightWrapper
              sx={
                skin === "bordered" && !hidden
                  ? { borderLeft: `1px solid ${theme.palette.divider}` }
                  : {}
              }
            >
              {hidden && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  marginBottom="2.5rem"
                  marginTop="2.5rem"
                >
                  <Box sx={{ pt: 2 }}>
                    <Logo />
                  </Box>
                </Box>
              )}

              {children}
            </RightWrapper>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default AuthLayout;
